import LoadMoreLogicWrapper from 'components/loadMore/LoadMoreLogicWrapper';

export default LoadMoreLogicWrapper;
